import React from 'react'
import AddOrganzationForm from "../../components/eventLayout/sponsors/AddOrganzationForm";

const RegisterExhibitorOrganization = () => {
  return (
    <AddOrganzationForm />
  )
}

export default RegisterExhibitorOrganization